import { createContext, useContext } from 'react'

export type ToastTone = 'success' | 'error'

export interface ToastOptions {
  tone?: ToastTone
}

export interface ToastContextValue {
  /** Announce a short, transient confirmation. For anything the citizen must act
   * on, use an inline `Alert` instead — a toast disappears on its own. */
  showToast: (message: string, options?: ToastOptions) => void
}

export const ToastContext = createContext<ToastContextValue | null>(null)

export function useToast(): ToastContextValue {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error('useToast must be used inside <ToastProvider>')
  }
  return context
}
